module.exports = __webpack_public_path__ + "static/media/10.6d8391cd.jpg";